import { AscendError } from "./ascend-error";
export const CommonClientErrorCodeList = [
    "common.not_found",
    "common.resource_not_found",
    "common.invalid_input",
    "common.invalid_operation",
    "common.invalid_value_object",
    "common.outdated_version",
    "common.too_many_resource_selected",
    "common.duplicate_resource",
    "common.conflicting_operation",
    "auth.unauthorized",
    "auth.not_permitted",
    "auth.invalid_credential",
    "auth.invalid_context",
    "auth.no_ascend_staff_header",
];
export class BaseClientError extends AscendError {
    isClientError = true;
    constructor(args, e) {
        super({ ...args, type: "client" }, e);
    }
}
class NotFound extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "NotFoundError",
            errorCode: "common.not_found",
            statusCode: 404,
            message: message,
            userMessage: userMessage ?? "対象が見つかりませんでした。",
        }, e);
    }
}
class ResourceNotFound extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "ResourceNotFoundError",
            errorCode: "common.resource_not_found",
            statusCode: 404,
            message: message,
            userMessage: userMessage ?? "対象が見つかりませんでした。",
        }, e);
    }
}
class InvalidInput extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidInputError",
            errorCode: "common.invalid_input",
            statusCode: 400,
            message: message,
            userMessage: userMessage ??
                "入力に誤りがあります。入力内容をご確認の上、再度お試しください。",
        }, e);
    }
}
class InvalidOperation extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidOperationError",
            errorCode: "common.invalid_operation",
            statusCode: 400,
            message: message,
            userMessage: userMessage ??
                "不正な操作がありました。操作内容をご確認の上、再度お試しください。",
        }, e);
    }
}
class InvalidValueObject extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidValueObjectError",
            errorCode: "common.invalid_value_object",
            statusCode: 400,
            message: message,
            userMessage: userMessage ??
                "入力値に誤りがあります。入力内容をご確認の上、再度お試しください。",
        }, e);
    }
}
class OutdatedVersion extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "OutdatedVersionError",
            errorCode: "common.outdated_version",
            statusCode: 400,
            message: message,
            userMessage: userMessage ??
                "対象が別の操作により更新済みです。再読み込みの上、もう一度お試しください。",
        }, e);
    }
}
class TooManyResource extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "TooManyResourceError",
            errorCode: "common.too_many_resource",
            statusCode: 400,
            message: message,
            userMessage: userMessage ??
                "規定以上の対象が選択されています。対象を絞った上で、再度お試しください。",
        }, e);
    }
}
class DuplicateResource extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "DuplicateResourceError",
            errorCode: "common.duplicate_resource",
            statusCode: 400,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class Conflicting extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "ConflictingError",
            errorCode: "common.conflicting_operation",
            statusCode: 409,
            message: message,
            userMessage: userMessage ??
                "他の操作と競合しました。時間をおいて、再度お試しください。",
        }, e);
    }
}
class Unauthorized extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "UnauthorizedError",
            errorCode: "auth.unauthorized",
            statusCode: 401,
            message: message,
            userMessage: userMessage ?? "認証されていません。再度ログインしてください。",
        }, e);
    }
}
class NotPermitted extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "NotPermittedError",
            errorCode: "auth.not_permitted",
            statusCode: 401,
            message: message,
            userMessage: userMessage ??
                "許可されていない操作が発生しました。操作が必要な場合は管理者権限を持つユーザーにご連絡ください。",
        }, e);
    }
}
class InvalidCredential extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidCredentialError",
            errorCode: "auth.invalid_credential",
            statusCode: 403,
            message: message,
            userMessage: userMessage ?? "認証されていません。再度ログインしてください。",
        }, e);
    }
}
class InvalidContext extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidContextError",
            errorCode: "auth.invalid_context",
            statusCode: 403,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class NoAscendStaffHeader extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "NoAscendStaffHeaderError",
            errorCode: "auth.no_ascend_staff_header",
            statusCode: 403,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
export const CommonClientError = {
    NotFound,
    ResourceNotFound,
    InvalidInput,
    InvalidOperation,
    InvalidValueObject,
    OutdatedVersion,
    TooManyResource,
    DuplicateResource,
    Conflicting,
    Unauthorized,
    NotPermitted,
    InvalidCredential,
    InvalidContext,
    NoAscendStaffHeader,
};
export const CommonClientErrorRegistry = {
    "common.not_found": NotFound,
    "common.resource_not_found": ResourceNotFound,
    "common.invalid_input": InvalidInput,
    "common.invalid_operation": InvalidOperation,
    "common.invalid_value_object": InvalidValueObject,
    "common.outdated_version": OutdatedVersion,
    "common.too_many_resource": TooManyResource,
    "common.duplicate_resource": DuplicateResource,
    "common.conflicting": Conflicting,
    "auth.unauthorized": Unauthorized,
    "auth.not_permitted": NotPermitted,
    "auth.invalid_credential": InvalidCredential,
    "auth.invalid_context": InvalidContext,
    "auth.no_ascend_staff_header": NoAscendStaffHeader,
};
//# sourceMappingURL=client-error.js.map